import React from 'react';
import { FaChevronUp } from 'react-icons/fa';
import css from './UpNavigation.module.css';

interface UpNavigationProps {
  onNavigateUp: () => void;
}

const UpNavigation: React.FC<UpNavigationProps> = ({ onNavigateUp }) => {
  return (
    <div className={css.upNavigation} onClick={onNavigateUp}>
      <FaChevronUp className={css.upIcon} />
      <span className={css.upNavigationText}>Back to parent folder</span>
    </div>
  );
};

export default UpNavigation;